export const switchStyle = {
  baseStyle: {
    container: {},
    track: {
      _checked: {
        bg: "primary",
        boxShadow: "none",
      },
    },
  },
};
